export var LockingCalcStatus;
(function (LockingCalcStatus) {
    LockingCalcStatus["RUNNING"] = "running";
    LockingCalcStatus["FAILED"] = "failed";
    LockingCalcStatus["CANCELLED"] = "cancelled";
    LockingCalcStatus["COMPLETED"] = "completed";
})(LockingCalcStatus || (LockingCalcStatus = {}));
//# sourceMappingURL=lockingCalcStatus.js.map